// extracted by mini-css-extract-plugin
module.exports = {"main":"Feedback_main__3apQY","textarea_input":"Feedback_textarea_input__mCfdW","footer_btn":"Feedback_footer_btn__22oNf"};